import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CreateCvService {

  @Output() openSidebar = new EventEmitter<boolean>();
  @Output() cvData = new EventEmitter<any>();

  constructor() { }

  openCreateSideBar() {
    this.openSidebar.emit(true);
  }

  closeCreateSideBar() {
    this.openSidebar.emit(false);
  }

  emitCvData(cv: any) {
    this.cvData.emit(cv);
  }
}
